import Component from '@bythepixel/component-loader';

export default class SectionHeaderCareersScroll extends Component {
  static selector = '[data-comp-section-header-careers-scroll]';

  constructor(containerEl) {
    super(containerEl);
    const mainHeader = document.querySelector('[data-comp-navigationheader]');

    /**
     * Observes the main top header, if it's out of the viewport, we've scrolled past it, and the page header is now sticky.
     * We add and remove the page header scroll class depending on whether that main header is in the viewport.
     */
    const observer = new IntersectionObserver(entry => {
      if (entry[0].intersectionRatio <= 0) {
        this.$container.classList.add('section-header-careers--scroll');
      } else {
        this.$container.classList.remove('section-header-careers--scroll');
      }
    });

    observer.observe(mainHeader);
  }
}
